import React from 'react';
import { Modal } from 'antd';
import useModal from 'stores/useModal';
import { useTranslation } from 'react-i18next';

function ConfirmModal() {
  const { t } = useTranslation();
  const { isOpenConfirmModal, propsConfirmModal, confirmLoading, setInfoConfirmModal } = useModal();

  const handleCancel = () => {
    setInfoConfirmModal(false, undefined);
  };

  return (
    <Modal
      title={propsConfirmModal?.title}
      className="modal-confirm"
      centered
      width={propsConfirmModal?.width || 420}
      open={isOpenConfirmModal}
      okText={propsConfirmModal?.okText || t('common.actions.confirm')}
      cancelText={propsConfirmModal?.cancelText || t('common.actions.cancel')}
      okButtonProps={{ className: 'ant-btn-secondary' }}
      onOk={propsConfirmModal?.onOk}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      destroyOnClose
    >
      {propsConfirmModal?.message && (
        <div style={{ fontWeight: 'bold' }}>{propsConfirmModal.message}</div>
      )}
      {propsConfirmModal?.subMessage && (
        <div style={{ fontWeight: 'bold' }}>{propsConfirmModal.subMessage}</div>
      )}
      {propsConfirmModal?.importantMessage && (
        <div style={{ fontWeight: 'bold' }}>{propsConfirmModal.importantMessage}</div>
      )}
    </Modal>
  );
}

export default ConfirmModal;
